import React, { useEffect, useState } from "react";
import { Workflow } from "lucide-react";
import { api } from "@/lib/api";
import CrudModule from "@/components/CrudModule";

export default function EnvAspects() {
  const [isoTitles, setIsoTitles] = useState(["—"]);
  useEffect(() => {
    api.get("/iso14001").then(({ data }) => {
      const titles = data.map((d) => d.title).filter(Boolean);
      setIsoTitles(["—", ...titles]);
    }).catch(() => {});
  }, []);

  return (
    <CrudModule
      title="Matriz de Aspectos e Impactos Ambientais"
      subtitle="Levantamento de aspectos, impactos e controles (ISO 14001 — 6.1.2)"
      icon={Workflow}
      endpoint="env-aspects"
      exportKey="env-aspects"
      testid="aspects"
      columns={[
        { key: "activity", label: "Atividade" },
        { key: "aspect", label: "Aspecto" },
        { key: "impact", label: "Impacto" },
        { key: "classification", label: "Classificação" },
        { key: "significance", label: "Significância", badge: true },
        { key: "control", label: "Controle" },
        { key: "iso_item_title", label: "Item ISO 14001" },
      ]}
      fields={[
        { name: "activity", label: "Atividade / Processo", type: "text", required: true, full: true },
        { name: "aspect", label: "Aspecto ambiental", type: "text", required: true, full: true },
        { name: "impact", label: "Impacto ambiental", type: "text", full: true },
        { name: "classification", label: "Classificação", type: "select", options: ["Normal", "Anormal", "Emergência"], default: "Normal" },
        { name: "significance", label: "Significância", type: "select", options: ["Significativo", "Não Significativo"], default: "Não Significativo" },
        { name: "control", label: "Medida de controle", type: "text", full: true },
        { name: "iso_item_title", label: "Item ISO 14001 vinculado", type: "select", options: isoTitles, default: "—", full: true },
        { name: "document", label: "Evidência (upload)", type: "file", idKey: "document_id", nameKey: "document_name", full: true },
      ]}
    />
  );
}
